
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Introducao from "../pages/introducao/page";
import Componentes from "../pages/componentes/page";
import Funcionamento from "../pages/funcionamento/page";
import Problemas from "../pages/problemas/page";
import Diagnostico from "../pages/diagnostico/page";
import Engenheiro from "../pages/engenheiro/page";
import Seguranca from "../pages/seguranca/page";
import ElektrischSchakelen from "../pages/elektrisch-schakelen/page";
import Quiz1 from "../pages/quiz1/page";
import Quiz2 from "../pages/quiz2/page";
import Quiz3 from "../pages/quiz3/page";
import Onderhoudstechniek from "../pages/onderhoudstechniek/page";
import QuizLogistiek from "../pages/quiz-logistiek/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/introducao",
    element: <Introducao />,
  },
  {
    path: "/componentes",
    element: <Componentes />,
  },
  {
    path: "/funcionamento",
    element: <Funcionamento />,
  },
  {
    path: "/problemas",
    element: <Problemas />,
  },
  {
    path: "/diagnostico",
    element: <Diagnostico />,
  },
  {
    path: "/engenheiro",
    element: <Engenheiro />,
  },
  {
    path: "/seguranca",
    element: <Seguranca />,
  },
  {
    path: "/elektrisch-schakelen",
    element: <ElektrischSchakelen />,
  },
  {
    path: "/quiz1",
    element: <Quiz1 />,
  },
  {
    path: "/quiz2",
    element: <Quiz2 />,
  },
  {
    path: "/quiz3",
    element: <Quiz3 />,
  },
  {
    path: "/onderhoudstechniek",
    element: <Onderhoudstechniek />,
  },
  {
    path: "/quiz-logistiek",
    element: <QuizLogistiek />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
